import React, {Component} from 'react';
import {connect} from "react-redux";
import logicGraphDataActions from "../../../actions/logicGraphDataActions";

import MaterialIcon from '../../MaterialIcon';
import uniqueId from 'lodash/uniqueId';
import {ReactSortable} from 'react-sortablejs';


import {removePort, addPort, editButton} from './InputPortListUtils/InputPortUtils';

import {clickedNodeAction} from '../../../actions/clickedNodeActions';


class InputPortList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            portList: [],
            options: {
                groupData: [],
                inputPortData: [],
                logDecisionName: null,
                settings: null,
                totalItemCount: null,
                checkSingleIteration: false,
            },
        };
        this.createList = this.createList.bind(this);
        this.createOption = this.createOption.bind(this);
        this.removePort = this.removePort.bind(this);
        this.addPort = this.addPort.bind(this);
        this.roundRobinStart = this.roundRobinStart.bind(this);
        this.roundRobinEnd = this.roundRobinEnd.bind(this);
        this.editButton = this.editButton.bind(this);
        this.inputHandle = this.inputHandle.bind(this);
        this.changeInput = this.changeInput.bind(this);
    }

    componentDidMount(){
        this.createList();
    }

    createList(){
        const engine = this.props.logicDataInfo
        const model = engine.getModel();
        const logicData = model.serialize();
        
        const clickedNodeInfo = Object.assign({}, this.props.clickedNodeInfo);
        const portList = [];
        const inputPortData = clickedNodeInfo.extras.options.inputPortData;

        const groupData = clickedNodeInfo.extras.options.groupData;
        Object.values(clickedNodeInfo.ports).forEach((v,i) => {
            const values = {
                groupID: uniqueId(),
                exclude: false,
                itemCount: null,
                logDecisionValue: '',
                randomize: false,
                useUnder: null,
                excludeUnder:null,
                maxLengthAfter: null
            };

            if(typeof inputPortData !== 'undefined' && inputPortData.length > 0 && v.options.in){
                values.groupID = typeof inputPortData[i] !== 'undefined' ? inputPortData[i].group : uniqueId();
                values.exclude = typeof inputPortData[i] !== 'undefined' ? inputPortData[i].exclude : false;
                values.itemCount = typeof inputPortData[i] !== 'undefined' ? inputPortData[i].itemCount : null;
                values.logDecisionValue = typeof inputPortData[i] !== 'undefined' ? inputPortData[i].logDecisionValue : '';
                values.randomize = typeof inputPortData[i] !== 'undefined' ? inputPortData[i].randomize : false;
                values.useUnder = typeof inputPortData[i] !== 'undefined' ? inputPortData[i].useUnder : null;
                values.excludeUnder = typeof inputPortData[i] !== 'undefined' ? inputPortData[i].excludeUnder : null;
                values.maxLengthAfter = typeof inputPortData[i] !== 'undefined' ? inputPortData[i].maxLengthAfter : null;
            }

            
            let groupRounds = 1;
            if(typeof groupData !== 'undefined' && groupData.length > 0){
                const groupDataResult = groupData.filter(item => item.groupID === values.groupID);
                if(groupDataResult.length > 0){
                    groupRounds = groupDataResult[0].rounds;
                }
            }


            let roundRobin = false;
            if(typeof clickedNodeInfo.extras.options.groupData !== 'undefined' && clickedNodeInfo.extras.options.groupData.length > 0){
                const result = clickedNodeInfo.extras.options.groupData.filter(item => item.groupID === values.groupID);
                roundRobin = result.length > 0;
            }

            const createData = {
                parentID: clickedNodeInfo.options.id,
                id: v.options.id,
                nodeName: 'Empty Input',
                branchName: '',
                groupID: values.groupID,
                index: 0,
                roundRobin: roundRobin,
                edit: false,
                sectionType: 'empty',
                groupData: {
                    groupID: values.groupID,
                    rounds: groupRounds,
                    randomizeAllRounds: false,
                    randomizeInsideRound: false
                },
                exclude: values.exclude,
                itemCount: values.itemCount,
                logDecisionValue: values.logDecisionValue,
                randomize: values.randomize,
                useUnder: values.useUnder,
                excludeUnder: values.excludeUnder,
                maxLengthAfter: values.maxLengthAfter,
                in: v.options.in
            }
            if(v.connection){
                let nodeID = '';
                Object.values(logicData.layers.filter(layer => layer.type === 'diagram-links')[0].models).forEach(link => {
                    if(link.sourcePort === v.options.id){
                        nodeID = link.target;
                    }
                    if(link.targetPort === v.options.id){
                        nodeID = link.source;
                    }   
                });
                const nodeData = Object.values(logicData.layers.filter(layer => layer.type === 'diagram-nodes')[0].models).filter(node => node.id === nodeID)[0];
                createData.nodeName = nodeData.name;
                createData.sectionType = nodeData.sectionType;
                createData.index = i
                portList.push(createData);
            }else {
                createData.index = i;
                portList.push(createData);
            }
        });

        const newPortList = [];
        const inputPortList = portList.filter(port => port.in);
        const outputPortList = portList.filter(port => port.in === false);
        inputPortList.forEach((v,i) => {
            v.index = i;
            newPortList.push(v);
        });
        outputPortList.forEach((v) => {
            newPortList.push(v);
        });
        
        this.setState(
            { portList: newPortList },
            () => this.createOption()
        );
    }

    createOption(){
        const inputPortData = [];
        const groupData = [];

        const portList = Object.values(Object.assign({}, this.state.portList));
        const inputPortList = portList.filter(port => port.in);
        inputPortList.forEach(v => {
            inputPortData.push({
                exclude: v.exclude,
                group: v.groupID,
                itemCount: v.itemCount,
                logDecisionValue: v.logDecisionValue,
                randomize: v.randomize,
                useUnder: v.useUnder,
                excludeUnder: v.excludeUnder,
                maxLengthAfter: v.maxLengthAfter
            });
            if(v.roundRobin){
                groupData.push({
                    groupID: v.groupID,
                    rounds: v.groupData.rounds,
                    randomizeAllRounds: v.groupData.randomizeAllRounds,
                    randomizeInsideRound: v.groupData.randomizeInsideRound
                });
            }
        });

        const uniqueGroupData = [];
        const map = new Map();
        for (const item of groupData) {
            if(!map.has(item.groupID)){
                map.set(item.groupID, true);
                uniqueGroupData.push({
                    ...item
                });
            }
        }

        uniqueGroupData.forEach(groupData => {
            portList.map(portData => {
                if(groupData.groupID === portData.groupID){
                    portData.groupData.groupID = groupData.groupID
                    portData.groupData.rounds = groupData.rounds
                    portData.groupData.randomizeAllRounds = groupData.randomizeAllRounds
                    portData.groupData.randomizeInsideRound = groupData.randomizeInsideRound
                }
                return portData;
            });
        });


        const options = Object.assign({}, this.state.options);
        options.inputPortData = inputPortData;
        options.groupData = uniqueGroupData;
        options.logDecisionName = this.props.clickedNodeInfo.extras.options.logDecisionName;
        options.totalItemCount = this.props.clickedNodeInfo.extras.options.totalItemCount;
        options.checkSingleIteration = this.props.clickedNodeInfo.extras.options.checkSingleIteration;
        options.settings = this.props.clickedNodeInfo.extras.options.settings;

        const logicGraphData = {
            options: options,
            portList: portList,
            id: this.props.clickedNodeInfo.options.id
        }
        this.props.logicGraphDataActions(logicGraphData);
        
        const clickedNodeInfo = Object.assign({}, this.props.clickedNodeInfo);
        clickedNodeInfo.extras.options = logicGraphData.options;
        this.props.clickedNodeAction(clickedNodeInfo);
    }
    
    removePort(item){
        const portList = removePort(this.state.portList,item);
        this.setState({
            portList: portList
        }, () => this.createOption());
        
    }
    addPort(){
        const portList = addPort(this.state, this.props.clickedNodeInfo.options.id, 'output');
        this.setState({
            portList: portList
        }, () => this.createOption());
    }
    roundRobinStart(item){
        const portList = Object.assign({}, this.state.portList);
        const setPortList = Object.values(portList).map(v => {
            if(v.id === item.id){
                v.roundRobin = true;
                v.groupID = uniqueId();
            }
            return v;
        });

        this.setState(
            { portList: setPortList },
            () => this.createOption()
        );
    }
    roundRobinEnd(item){
        const portList = Object.assign({}, this.state.portList);
        const setPortList = Object.values(portList).map((v) => {
            if(item.groupID === v.groupID){
                v.roundRobin = false;
            }
            return v;
        });
        this.setState(
            { portList: setPortList },
            () => this.createOption()
        );
    }
    editButton(item){
        const setEditValue = editButton(this.state.portList, item);
        this.setState({
            portList: setEditValue
        });

    }

    inputHandle(event,item, name){
        let process = false;
        const portList = Object.assign({}, this.state.portList);
        const setInputData = Object.values(portList).map((v) => {
            if(v.id === item.id){
                if(name === 'logDecisionValue' && v.logDecisionValue !== event.target.value){
                    v.logDecisionValue = event.target.value;
                    process = true;
                }
                if(name === 'itemCount' && v.itemCount !== event.target.value){
                    v.itemCount = event.target.value;
                    process = true;
                }
                if(name === 'useUnder' && v.useUnder !== event.target.value){
                    v.useUnder = event.target.value;
                    process = true;
                }
                if(name === 'excludeUnder' && v.excludeUnder !== event.target.value){
                    v.excludeUnder = event.target.value;
                    process = true;
                }
                if(name === 'maxLengthAfter' && v.maxLengthAfter !== event.target.value){
                    v.maxLengthAfter = event.target.value;
                    process = true;
                }
            }
            if(v.groupID === item.groupID){
                if(name === 'group-rounds' && v.groupData.rounds !== event.target.value){
                    v.groupData.rounds = event.target.value;
                    process = true;
                }
            }
            return v;
        });
        if(process){
            this.setState({
                portList: setInputData
            }, () => this.createOption());
        }
    }

    changeInput(event, name, item){
        const portList = Object.assign({}, this.state.portList);
        const setInputData = Object.values(portList).map((v) => {
            if(v.id === item.id){
                if(name === 'exclude') v.exclude = !v.exclude            
                if(name === 'randomize') v.randomize = !v.randomize
            }
            if(v.groupID === item.groupID){
                if(name === 'group-randomizeInsideRound') v.groupData.randomizeInsideRound = !v.groupData.randomizeInsideRound    
                if(name === 'group-randomizeAllRounds') v.groupData.randomizeAllRounds = !v.groupData.randomizeAllRounds    
            }
            return v;
        });        
        this.setState({
            portList: setInputData
        }, () => this.createOption());
    }



    render(){
        const roundRobinHTML = (val) => {
            return (
                <div className="round-robin-area">
                    <div className="round-robin-container">
                        <div className="rounds item">
                            <span>Round</span>
                            <input name="numberInput" className="panel-input" type="number" onBlur={(event) => this.inputHandle(event, val, 'group-rounds')} defaultValue={val.groupData.rounds} />
                        </div>
                        <label className="item">
                            <span>Randomize Inside</span>
                            <input type="checkbox" className="checkbox" checked={val.groupData.randomizeInsideRound} onChange={(event) => {this.changeInput(event, 'group-randomizeInsideRound', val)}} />
                        </label>
                        <label className="item">
                            <span>Randomize All</span> 
                            <input type="checkbox" className="checkbox" checked={val.groupData.randomizeAllRounds} onChange={(event) => {this.changeInput(event, 'group-randomizeAllRounds', val)}} />
                        </label>
                        <button className="remove-button item" onClick={() => this.roundRobinEnd(val)}><MaterialIcon icon="close"/></button>
                    </div>
                </div>
            )
        }
        const defaultPort = (data) => {
            if (data.length === 0) return [];
            const lastPort = this.state.portList[this.state.portList.length - 1].id;
            return data.map((val,key) => {
                return (
                    <div className={`input-area ${val.sectionType}`} data-id={val.id} key={val.id}>
                        {val.roundRobin === true && key === 0  && roundRobinHTML(val)}
                        <div className="input-container">
                            <div className="input">
                                <div className="input-name">
                                    <span className="name">{val.nodeName}</span>
                                    <span className="input-index">{val.index}</span>
                                </div>
                                <div className="drag-handle">
                                    <MaterialIcon icon="drag_indicator" size={24}/>
                                </div>
                                <div className="input-editor">
                                    <span className="input-editor-name">Branch<br />Name</span>
                                    <input className="panel-input" onClick={(event) => event.target.focus()} onBlur={(event) => this.inputHandle(event, val, 'logDecisionValue')} defaultValue={val.logDecisionValue} type="text" placeholder="Branch Name" key={"branchName" + key}/>
                                </div>
                                <div className="action-area">
                                    <button className={`edit-button ${val.edit ? 'active' : ''}`} onClick={()=> this.editButton(val)}>Edit<MaterialIcon icon="keyboard_arrow_down" size={24}/></button>
                                    {/* {
                                        !val.roundRobin && 
                                        <button className="round-robin-button round" onClick={() => this.roundRobinStart(val)}><MaterialIcon icon="replay"/></button>
                                    } */}
                                    {
                                        val.id !== lastPort &&
                                        <button className="remove-button round" onClick={() => this.removePort(val)}><MaterialIcon icon="close"/></button>
                                    }
                                </div>
                            </div>
                            <div className={`input-dropdown ${val.edit ? 'active' : ''}`}>
                                <div className="dropdown-container">
                                    <label className="item">
                                        <input type="checkbox" checked={val.exclude} onChange={(event) => {
                                            this.changeInput(event, 'exclude', val)
                                        }} className="checkbox"/>
                                        <span>Exclude</span>
                                    </label>

                                    <label className={`item ${val.exclude ? 'hidden' : ''}`}>
                                        <span>Limit Item Count</span>
                                        <input className="panel-input" type="number" name="name-input"
                                               onClick={(event) => event.target.focus()}
                                               onBlur={(event) => this.inputHandle(event, val, 'itemCount')}
                                               defaultValue={val.itemCount} key={"limitInputCount" + key}/>
                                    </label>
                                    {/*
                                         <label className={`item ${val.exclude ? 'hidden' : ''}`}>
                                        <input type="checkbox" className="checkbox" checked={val.randomize} onChange={(event) => {this.changeInput(event, 'randomize', val)}} />
                                        <span>Randomize</span>
                                    </label>
                                    */}

                                    <label className={`item ${val.exclude ? 'hidden' : ''}`}>
                                        <span>Use Under</span>
                                        <input className="panel-input" type="number" name="use-under"
                                               onClick={(event) => event.target.focus()}
                                               onBlur={(event) => this.inputHandle(event, val, 'useUnder')}
                                               defaultValue={val.useUnder} key={"useUnder" + key}/>
                                    </label>
                                    <label className={`item ${val.exclude ? 'hidden' : ''}`}>
                                        <span>Exclude Under</span>
                                        <input className="panel-input" type="number" name="exclude-under"
                                               onClick={(event) => event.target.focus()}
                                               onBlur={(event) => this.inputHandle(event, val, 'excludeUnder')}
                                               defaultValue={val.excludeUnder} key={"excludeUnder" + key}/>
                                    </label>
                                    <label className={`item ${val.exclude ? 'hidden' : ''}`}>
                                        <span>Max Length After</span>
                                        <input className="panel-input" type="number" name="max-length-after "
                                               onClick={(event) => event.target.focus()}
                                               onBlur={(event) => this.inputHandle(event, val, 'maxLengthAfter')}
                                               defaultValue={val.maxLengthAfter} key={"maxLengthAfter" + key}/>
                                    </label>
                                </div>
                            </div>
                        </div>
                        {val.roundRobin === true && key === (data.length - 1) && <div className="border-line"></div>}
                    </div>
                )
            })
        }
        const groupCreate = () => {
            const thisElement = this;
            const portListData = this.state.portList.filter(port => port.in);

            const roundRobin = portListData.filter(port => port.roundRobin).length > 0 ? 'round-robin' : '';
            return (
                <ReactSortable key = "static"
                    animation = {150}
                    handle = '.drag-handle' 
                    group = {'default_group' + uniqueId()}
                    pull = {true}
                    put = {true}

                    onAdd = {(evt) => {
                        const item = evt.item.dataset.id;
                        const groupID = evt.target.className.split('group-')[1];
                        const groupList = portListData.filter(port => parseInt(port.groupID) === parseInt(groupID))[0];
                        if(groupList.roundRobin){
                            portListData.map(v => {
                                if(v.id === item){
                                    v.roundRobin = true;
                                }
                                return v;
                            });
                        }else {
                            portListData.map(v => {
                                if(v.id === item){
                                    v.roundRobin = false;
                                } 
                                return v;
                            });
                        }
                    }}

                    list={portListData}
                    setList = {(newState)=> {
                        if (portListData.length !== newState.length || !portListData.every((val, index) => val === newState[index])) {
                            const newPortList = [...newState];
                            newPortList.forEach((val,key) => {
                                val.index = key;
                                return val;
                            });
                            const outputPortList = this.state.portList.filter(port => port.in === false);
                            outputPortList.forEach((v) => {
                                newPortList.push(v);
                            });
                            
                            thisElement.setState(
                                { portList: newPortList },
                                () => thisElement.createOption()
                            );
                        }
                    }}
                    className={`list-area ${roundRobin} group-${portListData.length ? portListData[0].groupID : ''}`}
                >
                    {defaultPort(portListData)}
                </ReactSortable>
            )
        }
        return (
            <div className="node-input-list">
                {
                    this.state.portList && groupCreate()
                }
                <div className="bottom-button-area">
                    <button className="add-button" onClick={this.addPort}><MaterialIcon icon="add_circle"/>Add Input</button>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        clickedNodeInfo: state.clickedNodeInfo,
        logicDataInfo: state.logicDataInfo,
        logicGraphData: state.logicGraphData
    }
}
export default connect(mapStateToProps, {clickedNodeAction,logicGraphDataActions})(InputPortList);
